<template>
    <div
        class="flex flex-col h-full max-h-[100dvh] md:h-auto md:max-h-none md:block"
    >
        <!-- Header: judul + tutup (mobile drawer) -->
        <div
            class="flex items-center justify-between px-4 py-3 border-b border-gray-100 md:px-0 md:pt-0 md:border-0"
        >
            <h3 class="text-lg font-semibold">Filters</h3>
            <button
                type="button"
                class="p-1 -mr-1 text-gray-500 rounded-lg md:hidden active:bg-gray-100"
                aria-label="Close filters"
                @click="$emit('close')"
            >
                <AppIcon icon="mdi:close" width="22" height="22" />
            </button>
        </div>

        <div
            class="flex-1 min-h-0 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] overflow-y-auto md:overflow-visible md:p-0 md:pt-4"
        >

        <!-- Render Dinamis Berdasarkan Konfigurasi -->
        <div v-for="(item, index) in filterConfig" :key="index" class="mb-4">
            <label class="block mb-2 text-sm font-medium">{{
                item.type === "dateRange" && isFixedPeriod
                    ? $t("checkIn")
                    : item.label
            }}</label>

            <!-- Select Filter -->
            <BaseSelectIcon
                v-if="item.type === 'select'"
                :options="item.options ? options[item.options] : []"
                v-model="localFilter[item.model]"
                :placeholder="item.placeholder"
                class="w-full"
            />

            <!-- Date: Bulanan/Tahunan = check-in saja (checkout dihitung), Harian = range -->
            <template v-if="item.type === 'dateRange'">
                <BaseDatePickerCompact
                    v-if="isFixedPeriod"
                    dialog
                    :placeholder="$t('selectDate')"
                    iconBack="mdi:calendar"
                    :modelValue="localFilter[item.model] && localFilter[item.model].startDate"
                    @update:modelValue="(d) => setFixedPeriodCheckIn(d, item.model)"
                    :is-open="fixedDateOpen"
                    @open="fixedDateOpen = true"
                    @close="fixedDateOpen = false"
                    cssClass="flex items-center border border-gray-300 rounded-lg px-3 py-2 w-full cursor-pointer"
                />
                <BaseDateRangePicker
                    v-else
                    dialog
                    v-model="localFilter[item.model]"
                    class="w-full"
                />
            </template>

            <!-- Radio Buttons -->
            <div v-if="item.type === 'radio'">
                <label
                    v-for="option in item.options"
                    :key="option.value"
                    class="flex items-center gap-2"
                >
                    <input
                        type="radio"
                        v-model="localFilter[item.model]"
                        :value="option.value"
                    />
                    {{ option.label }}
                </label>
            </div>

            <!-- Range Input -->
            <div v-if="item.type === 'range'" class="flex gap-2">
                <input
                    type="number"
                    v-model="localFilter[item.modelMin]"
                    placeholder="Min"
                    class="w-1/2 p-2 border rounded"
                />
                <input
                    type="number"
                    v-model="localFilter[item.modelMax]"
                    placeholder="Max"
                    class="w-1/2 p-2 border rounded"
                />
            </div>

            <!-- Checkbox Group -->
            <div v-if="item.type === 'checkbox'">
                <label
                    v-for="option in options[item.options]"
                    :key="option.id"
                    class="flex items-center gap-2"
                >
                    <input
                        type="checkbox"
                        v-model="localFilter[item.model]"
                        :value="option.id"
                    />
                    {{ option.name }}
                </label>
            </div>
        </div>

            <!-- Actions: ikut mengalir setelah field terakhir -->
            <div class="flex gap-2 mt-6">
                <BaseButton type="secondary" class="w-1/2" @click="clearFilters"
                    >Clear</BaseButton
                >
                <BaseButton type="primary" class="w-1/2" @click="applyFilters"
                    >Apply</BaseButton
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FilterSidebar",
    props: {
        filterConfig: {
            type: Array,
            required: true,
        },
        filter: {
            type: Object,
            required: true,
        },
        options: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            localFilter: { ...this.filter },
            fixedDateOpen: false,
        };
    },
    computed: {
        // Bulanan(2) & Tahunan(3) = checkout terkunci, dihitung PropertiesPage.handleApplyFilters.
        // Samakan dgn isFixedPeriod() di sana — dulu di sini hanya `=== 2`, jadi Tahunan
        // kebagian date-range picker dan checkout pilihan tamu diam-diam ditimpa saat Apply.
        isFixedPeriod() {
            return Number(this.localFilter.period) !== 1;
        },
    },
    mounted() {
        console.log("Filter Config:", this.filterConfig);
        console.log("Filter Options:", this.options);
        console.log("Location Options:", this.options.locationsOptions);
    },
    methods: {
        clearFilters() {
            this.localFilter = { ...this.filter };
            this.$emit("clear");
        },
        applyFilters() {
            this.$emit("apply", this.localFilter);
        },
        // Bulanan/Tahunan: hanya pilih check-in; checkout dihitung di PropertiesPage.handleApplyFilters
        setFixedPeriodCheckIn(date, model) {
            this.localFilter[model] = { startDate: date, endDate: date };
        },
    },
};
</script>

<style scoped>
.sidebar {
    transition: transform 0.3s ease-in-out;
}
</style>
